<template>
  <v-container fluid no-gutters>
    <div class="text-lg font-medium mt-6"><b>Configurations</b></div>
    <div class="titles mt-6">SMS Providers</div>
    <v-card outlined class="mb-8">
      <v-card-text>
        <v-row>
          <v-col md="12" class="">
            <v-radio-group v-model="configurations.sms_provider" row>
              <v-radio
                v-for="provider in sms_providers"
                :key="provider.id"
                :label="provider.name"
                color="primary darken-3"
                :value="provider.id"
              ></v-radio>
            </v-radio-group>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <div class="titles mt-6">Error Logs</div>
    <v-card outlined class="mb-8">
      <v-card-text>
        <v-row>
          <v-col md="12">
            <v-checkbox
              v-model="configurations.enable_error_log"
              label="Send Error Logs via Email"
              color="primary darken-3"
            ></v-checkbox>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn
        class="ma-2 white--text teal-color"
        height="45"
        text
        @click="submitData()"
        >Save
      </v-btn>
    </v-card-actions>
  </v-container>
</template>

<script>
export default {
  components: {},
  mounted() {
    this.getConfigurations();
  },
  computed: {},
  data() {
    return {
      configurations: {
        sms_provider: null,
      },
      sms_providers: [],
    };
  },
  watch: {},
  methods: {
    getConfigurations() {
      this.showLoader("Loading");

      this.$http
        .get("global-configurations")
        .then((response) => {
          if (response.status == 200 && response.data.data) {
            // Initialize sms_providers as an empty array
            this.sms_providers = [];

            response.data.data.forEach((config) => {
              if (config.slug === "sms-provider") {
                // Add to sms_providers array
                this.sms_providers.push(config);
                if (config.is_enabled == 1)
                  this.configurations.sms_provider = config.id;
              } else if (config.slug === "error-mail-log") {
                this.configurations.enable_error_log = config.is_enabled;
              }
            });
          }
        })
        .catch((error) => {
          this.showError(error);
        })
        .finally(() => {
          this.hideLoader();
        });
    },

    submitData() {
      this.showLoader("Loading");

      let data = this.configurations;
      console.log("data");
      console.log(data);
      this.$http
        .post(`global-configurations`, data)
        .then((response) => {
          if (response.status == 200 && response.data.status == true) {
            this.showSuccess("Configuration saved successfully.");
            this.getConfigurations();
          }
        })
        .catch((error) => {
          this.errorChecker(error);
        });
      this.hideLoader();
    },
  },
};
</script>

<style scoped>
.salesBtn {
  padding: 5px;
  font-size: 14px;
  font-weight: bold;
  color: #066a8c;
}

.btn_bg {
  background-color: #fff;
  border-bottom: 3px solid #066a8c;
  border-radius: 10px;
  box-shadow: 0 3px 3px -2px black;
}
</style>
